const originalStyles = {
  container: {
    marginTop: "20px",
    padding: "20px",
    border: "1px solid #ddd",
    borderRadius: "8px",
  },
  title: {
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "16px",
  },
  button: {
    padding: "8px 16px",
    fontSize: "14px",
    borderRadius: "4px",
    border: "none",
    cursor: "pointer",
    backgroundColor: "#007bff",
    color: "white",
    fontWeight: "bold",
  },
  buttonDisabled: {
    backgroundColor: "#ccc",
    cursor: "not-allowed",
  },
  statusContainer: {
    marginTop: "16px",
  },
  statusItem: {
    display: "flex",
    alignItems: "center",
    marginBottom: "8px",
  },
  statusDot: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    marginRight: "8px",
  },
  message: {
    marginTop: "16px",
    padding: "12px",
    backgroundColor: "#f8f9fa",
    borderRadius: "4px",
    fontSize: "14px",
  },
  results: {
    marginTop: "16px",
    padding: "12px",
    backgroundColor: "#f8f9fa",
    borderRadius: "4px",
  },
  resultsTitle: {
    fontWeight: "bold",
    marginBottom: "8px",
    fontSize: "14px",
  },
  resultsList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
  },
  resultItem: {
    marginBottom: "4px",
    fontSize: "14px",
  },
} as const;

const additionalStyles = {
  resultsSummary: {
    marginBottom: "16px",
    padding: "8px",
    backgroundColor: "#e9ecef",
    borderRadius: "4px",
    fontSize: "14px",
  },
  artistResults: {
    marginTop: "16px",
  },
  artistResultsTitle: {
    fontSize: "14px",
    fontWeight: "bold",
    marginBottom: "8px",
  },
  artistResultItem: {
    padding: "8px",
    borderBottom: "1px solid #dee2e6",
  },
  artistName: {
    fontSize: "14px",
    fontWeight: "bold",
    marginBottom: "4px",
  },
  artistStats: {
    fontSize: "13px",
    color: "#666",
  },
  separator: {
    margin: "0 8px",
    color: "#ccc",
  },
  successText: {
    color: "#28a745",
  },
  errorText: {
    color: "#dc3545",
  },
};

// 기존 styles 객체에 새로운 스타일 추가
export const styles = {
  ...originalStyles,
  ...additionalStyles,
} as const;
